import { render, staticRenderFns } from "./DirectSignRecord.vue?vue&type=template&id=72c19f42&scoped=true"
import script from "./DirectSignRecord.vue?vue&type=script&lang=ts"
export * from "./DirectSignRecord.vue?vue&type=script&lang=ts"
import style0 from "./DirectSignRecord.vue?vue&type=style&index=0&id=72c19f42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c19f42",
  null
  
)

export default component.exports